export default __webpack_public_path__ + "static/media/shuffle.7b5ac91d.svg";